import { ConversationMessageStatus } from '../modules/conversations';

export const CONVERSATION_MESSAGE_STATUS: { [key: string]: ConversationMessageStatus } = {
  DELETED: 'deleted',
};
